import React, { cloneElement, Component } from 'react';
import { FormControl, TextField } from '@material-ui/core/index';
import { any, arrayOf, element, func, shape, string } from 'prop-types';
import { get, includes } from 'lodash';
import { timeZoneType } from '../constants';

import classnames from 'classnames';
import styles from './styles.scss';

export default class TimeZoneSearchField extends Component {
  static propTypes = {
    data: arrayOf(timeZoneType),
    searchPlaceHolder: string,
    classes: shape({ any }),
    onChange: func,
    startAdornment: element,
    searchableProps: arrayOf(string),
  };

  static defaultProps = {
    data: [],
    searchPlaceHolder: '',
    classes: {},
    searchableProps: ['name', 'abbv'],
  };

  state = {
    searchString: ''
  };

  handleTextInputChange = (event) => {
    event.preventDefault();
    const newSearch = event.target.value;

    this.setState({ searchString: newSearch });
    this.handleSearch(newSearch);
  };

  handleSearch(searchString) {
    const { data, onChange, searchableProps } = this.props;

    const normalizedSearchString = searchString.toLowerCase();
    const searchResults = data && data.reduce((accum, currentEntry) => {
      const { name, timezoneKey } = currentEntry;
      const key = `${name}_${timezoneKey}`;

      searchableProps.forEach(prop => {
        const searchableContents = get(currentEntry, prop, '').toLowerCase();
        if (includes(searchableContents, normalizedSearchString) && !accum[key]) {
          accum[key] = currentEntry;
        }
      });
      return accum;
    }, {});

    onChange && onChange(Object.values(searchResults), searchString);
  }

  render() {
    const {
      classes,
      startAdornment,
      searchPlaceHolder
    } = this.props;
    const { searchField } = classes;
    const { searchString } = this.state;
    return (
      <FormControl className={classnames(styles.formControl)}>
        <TextField
          data-test="timezoneSearchBox"
          className={classnames(styles.searchField, searchField)}
          onChange={this.handleTextInputChange}
          value={searchString}
          variant='outlined'
          placeholder={searchPlaceHolder}
          InputProps={{
            startAdornment: startAdornment && cloneElement(startAdornment)
          }}
        />
      </FormControl>
    );
  }
}
